import { render, staticRenderFns } from "./VideoViewer.vue?vue&type=template&id=8927c954&scoped=true&"
import script from "./VideoViewer.vue?vue&type=script&lang=js&"
export * from "./VideoViewer.vue?vue&type=script&lang=js&"
import style0 from "./VideoViewer.vue?vue&type=style&index=0&id=8927c954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8927c954",
  null
  
)

export default component.exports
import {QBtn,QResponsive} from 'quasar'
component.options.components = Object.assign({QBtn,QResponsive}, component.options.components || {})
